import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class FooterPagesService {

  constructor(private httpClient: HttpClient) { }
  public saveContactUsForm(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.FOOTER_PAGES.SAVE_CONTACT_US_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body);
  }
  public getFaqDetails(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.FOOTER_PAGES.GET_FAQ_DETAILS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
}
